import {useNavigate} from "react-router-dom";
import {useSetUserSession} from "../../../state/user-session";
import {useEffect} from "react";
import {queryStringToObject} from "../../../utils/collection-util";
import {callBackLogin} from "../domain/callback-login";

export function CallbackKakaoLogin() {
    const navigate = useNavigate();
    const [login,] = useSetUserSession()

    if (!window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_JS_KEY);
    }

    useEffect(() => {
        async function getToken() {
            const _params = new URLSearchParams(window.location.search)
            const code = _params.get('code')

            const res = await fetch(`https://kauth.kakao.com/oauth/token`, {
                body: `grant_type=authorization_code&client_id=${process.env.REACT_APP_KAKAO_REST_KEY}&redirect_uri=${process.env.REACT_APP_KAKAO_REDIRECT_URL}&code=${code}`,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                method: "POST"
            })

            const token_data = await res.json();
            const token = token_data.access_token;

            const queryParams = queryStringToObject(window.location.href.split('?')[1]);
            const params = queryStringToObject(queryParams.state);

            params.oauthProvider = "KAKAO";
            params.oauthAccessToken = token;

            await callBackLogin(navigate, login, params);
        }

        getToken();
    }, [])
}
